import ReactHtmlParser, { Transform } from 'react-html-parser';

// TODO: Fix it also from the source; it's the react-quill that adds the contenteditable to the generated content

/** To fix this react warning (It was seen on the AssistantMessage composant: items.longMessage may have some nodes with contenteditable setted)
    * Warning: A component is `contentEditable` and contains `children` managed by React. 
      It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. 
      This is probably not intentional.
*/
const transform: Transform = (node, index: number, transform) => {
  if (node.attribs && node.attribs.contenteditable === 'false') {
    delete node.attribs.contenteditable; // Remove the contentEditable attribute if it's false
  }
  return transform ? transform?.(node, index, transform) : undefined;
};

export const htmlParser = (content: string) => {
  return ReactHtmlParser(content, { transform });
};
